const EmailIconV2 = () => {
  return (
    <svg width="21" height="17" viewBox="0 0 21 17" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M20.8125 1.62393C20.625 0.90218 20.0625 0.180436 19.125 0C18.9375 0 18.9375 0 18.75 0H2.0625C1.875 0 1.875 0 1.6875 0C0.937501 0.180436 0.1875 0.721744 0 1.62393C0 1.80436 0 1.80436 0 1.9848V9.92399V14.074C0 14.6153 0.1875 15.1566 0.5625 15.5175C0.9375 15.8784 1.5 16.0588 2.0625 16.0588H9.375H11.625H18.9375C19.5 16.0588 20.0625 15.8784 20.4375 15.5175C20.8125 15.1566 21 14.6153 21 14.074V9.92399V1.9848C20.8125 1.80436 20.8125 1.80436 20.8125 1.62393ZM2.0625 3.9696V1.9848L10.5 7.03701L18.9375 1.9848V3.9696L10.3125 9.02181L2.0625 3.9696Z" fill="#808080"/>
    </svg>
  )
}

export default EmailIconV2;
